export default __webpack_public_path__ + "static/media/xbox-blue.c26a212f.png";